var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('article',[_c('infinite-scroll',[_c('class-list',{attrs:{"user":_vm.user,"profile":_vm.profile}}),_vm._v(" "),(_vm.loading)?_c('span',{staticClass:"loader"}):_vm._e()],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }